import React from "react";
import { Box, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { CheckCircleOutline, EditCalendar, ErrorOutline, History } from "@mui/icons-material";
import { formatDateWithTime } from "../../helpers";
import {
  IAcitvityInvoiceLogsProps,
} from "./Activity.types";
import { useDispatchWrapper } from "../../hooks";
import { useSelector } from "react-redux";
import { IStoreState } from "../../redux/initialStoreState";
import { ERROR_MESSAGES, LoadState } from "../../constants/enums";
import { fetchCustomerInvoiceListAsync } from "../../redux/activity/activityActions";
import { IInvoiceInformation } from "../../redux/Accounting/InvoiceInformation/InvoiceInformation.types";
import { StatusRenderer } from "../ActiveInActiveStatus/ActiveInActiveStatus";

export const ActivityInvoiceLogs: React.FC<IAcitvityInvoiceLogsProps> = (
  props
) => {
  const { moduleInformation,customerId } = props;

  const { list, loading } = useSelector(
    (storeState: IStoreState) => storeState.acitivty.invoice
  );

  const theme = useTheme();

  const dispatch = useDispatchWrapper();

  const fetchData = async () => {
    if(customerId){
        dispatch(fetchCustomerInvoiceListAsync(customerId));
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Stack mt={3}>
        <Stack
          padding={1}
          sx={{
            backgroundColor: theme.palette.grey[200],
            borderRadius: 1,
          }}
        >
          <Typography variant="h5" fontWeight={600}>
            Logs
          </Typography>
        </Stack>
        <Stack direction={"column"} spacing={1} mt={3}>
          {loading === LoadState.InProgress && (
            <>
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
            </>
          )}
          {loading === LoadState.Loaded && list.length === 0 && (
            <>
              <Box
                minHeight={100}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Box display={"flex"} justifyContent={"center"} mb={1}>
                  <ErrorOutline />
                </Box>
                <Box display={"flex"} justifyContent={"center"} width={"80%"}>
                  <Typography
                    variant="body1"
                    textAlign={"center"}
                    fontWeight={600}
                  >
                    {ERROR_MESSAGES.NO_RECORD_FOUND}
                  </Typography>
                </Box>
              </Box>
            </>
          )}

          {list.map((item, index) => {
            return <Row key={index} data={item} />;
          })}
        </Stack>
      </Stack>
    </>
  );
};

const Row: React.FC<{ data: IInvoiceInformation }> = ({ data }) => {
  const theme = useTheme();

  const handleOpen = () => {
    window.open(`/invoices/payment/history/${data.invoice_id}`, "_blank")
  }

  return (
    <Stack position={"relative"} minHeight={"80px"} sx={{cursor: "pointer"}} onClick={handleOpen}>
      <Stack
        direction={"row"}
        spacing={1.5}
        sx={{
         ":before": {
            content: "''",
            height: "100%",
            width: "2px",
            position: "absolute",
            left: "18px", // <-- fixed position for vertical line
            top: 0,
            bottom: 0,
            zIndex: 0,
            backgroundColor: theme.palette.warning.main,
          },
        }}
      >
        <Box
          border={"1px solid #fff"}
          sx={{ backgroundColor: "#fff" }}
          zIndex={1}
          height={"fit-content"}
        >
          {data.invoice_status === "DRAFT" && (
            <EditCalendar color="disabled" fontSize="large" />
          )}
           {data.invoice_status === "PAID" && (
            <CheckCircleOutline color="success" fontSize="large" />
          )}
           {data.invoice_status === "PARTIALLY PAID" && (
            <ErrorOutline color="error" fontSize="large" />
          )}
           {data.invoice_status === "UNPAID" && (
            <History color="warning" fontSize="large" />
          )}
           {!data.invoice_status && (
            <History color="warning" fontSize="large" />
          )}
        </Box>
        <Stack width={"100%"}>
          <Stack
            direction={"row"}
            flexWrap={"wrap"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography
              variant="body1"
              fontSize={"1.1rem"}
              maxWidth={"55%"}
              textOverflow={"ellipsis"}
              overflow={"hidden"}
              whiteSpace={"nowrap"}
              fontWeight={600}
            >
              {`Policy Number`}
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {data.insert_ts ? formatDateWithTime(data.insert_ts) : ""}
            </Typography>
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography variant="body1" fontWeight={500}>
              {data.policy_number}
            </Typography>
     
            <StatusRenderer status={data.invoice_status || data.status}/>

        
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography variant="h5" fontWeight={800}>
              Total Amount
            </Typography>
            <Typography variant="body1" fontWeight={500} color="success">
              {data.total_due_dollar}
            </Typography>
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography variant="h5" fontWeight={500}>
              Amount Paid
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {data.amount_paid || 0}
            </Typography>
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography variant="h5" fontWeight={500}>
              Amount Due
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {data.amount_due || 0}
            </Typography>
          </Stack>
          {/* <Typography variant="body1" fontWeight={500}>
            Created By : <span style={{marginLeft: 2}}>{task.craeted_by_name}</span>
          </Typography> */}
        </Stack>
      </Stack>
    </Stack>
  );
};
